import React from 'react'
import styled from 'styled-components'
import { NavBar } from '../../components/navbar'
import { check_icon } from '../../assets'
import { colors } from '../../colors'
import { Button } from '../../components/button'
import { Link } from 'react-router-dom'
import { IoMdArrowBack } from 'react-icons/io'

import { 
    Container,
    InputContainer
 } from '../signup'


const PasswordReset = () => {
  return (
    <Container>
        <NavBar/>

        <form >
            <img src={check_icon} alt="" />
            <h1>Password Reset</h1>
            <p>Your password has been successfully reset. Click below to log in magically.</p>
            
    
            <Button filled bgColor={'#2A870E'} to='https://mail.google.com/mail/' noIcon text={'Continue'} />

        </form>


        <small>  <Link to='/login'> <IoMdArrowBack/> Back to log in</Link> </small>
    </Container>
  )
}

export {PasswordReset}